import { render, staticRenderFns } from "./chatlist.vue?vue&type=template&id=6f171388&scoped=true"
import script from "./chatlist.vue?vue&type=script&lang=js"
export * from "./chatlist.vue?vue&type=script&lang=js"
import style0 from "./chatlist.vue?vue&type=style&index=0&id=6f171388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f171388",
  null
  
)

export default component.exports